// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OLjK","label":"styles_label__2zoU5"};